export interface IUser extends IUserAccessPermissions {
  firstName: string;
  lastName: string;
  emailAddress: string;
  bMainAccountHolder: boolean;
  insertionsStatus?: any;
}

export interface IUserAccessPermissions {
  bGetSet4PE: boolean;
  bGetSet4Music: boolean;
}

export interface IGetUserResponse {
  firstName: string;
  lastName: string;
  emailAddress: string;
  mainAccountHolder: boolean;
  suppressed: boolean;
  getSet4PE: boolean;
  getSet4Music: boolean;
  bSubscriptions: boolean;
  bManageUsers: boolean;
  bManageSchool: boolean;
  bInvoices: boolean;
}

export interface ManageUserBulkResponse {
  countInserted: number;
  insertionsStatus: any;
  recordsInserted: any;
}

export interface IGetUserAccessPermissionsResponse {
  getSet4PE: boolean;
  getSet4Music: boolean;
  bSubscriptions: boolean;
  bManageUsers: boolean;
  bManageSchool: boolean;
  bInvoices: boolean;
}

export interface ISubscriptionItem {
  label: string;
  fieldName: string;
}

export enum AccessPermissions {
  MANAGEUSERS = 'Manage users',
  MANAGESCHOOL = 'Manage school',
  INVOICES = 'Invoices',
  SUBSCRIPTIONS = 'Subscriptions',
}

export class UsersParser {
  public static createEmptyUser = (): IUser => ({
    firstName: '',
    lastName: '',
    emailAddress: '',
    bMainAccountHolder: false,
    bGetSet4PE: true,
    bGetSet4Music: true,
  });

  public static parseGetUserDetails = (response: IGetUserResponse): IUser => {
    const hasAccessToGetSet4Education =
      response.bInvoices ||
      response.bManageSchool ||
      response.bManageUsers ||
      response.bSubscriptions;

    return {
      firstName: response.firstName,
      lastName: response.lastName,
      emailAddress: response.emailAddress,
      bMainAccountHolder: response.mainAccountHolder,
      bGetSet4PE: response.getSet4PE,
      bGetSet4Music: response.getSet4Music,
    };
  };

  public static parseGetUserAccessPermissions = (
    response: IGetUserAccessPermissionsResponse
  ): IUserAccessPermissions => {
    const hasAccessToGetSet4Education =
      response.bInvoices ||
      response.bManageSchool ||
      response.bManageUsers ||
      response.bSubscriptions;
    return {
      bGetSet4PE: response.getSet4PE,
      bGetSet4Music: response.getSet4Music,
    };
  };

  public static buildUserPayload = (values: IUser): any => ({
    firstName: values.firstName,
    lastName: values.lastName,
    emailAddress: values.emailAddress,
    bMainAccountHolder: values.bMainAccountHolder,
    platforms: {
      bGetSet4PE: values.bGetSet4PE,
      bGetSet4Music: values.bGetSet4Music,
    },
  });

  public static buildAccessPermissionsPayload = (
    values: IUserAccessPermissions,
    id: number
  ): any => ({
    schoolUsersID: id,
    platforms: {
      bGetSet4PE: values.bGetSet4PE,
      bGetSet4Music: values.bGetSet4Music,
    },
  });

  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'EmailAddress_Already_Exists':
        error = 'Email address already exists';
        break;
      case 'OfficeEmailAddress_Already_Exists':
        error = 'Office email address already exists';
        break;        
      case 'Invalid_RemoveSelfMainAccountHolder':
        error = "You can't remove yourself as main account holder";
        break;
      case 'Invalid_Deleting_Main_Account_Holder':
        error = "You can't delete a main account holder";
        break;
      default:
        error = 'Sorry, something went wrong. Please try again.';
    }
    return error;
  };
  

  public static parseUserBulkDetails = (response: ManageUserBulkResponse) => {
    return {
      countInserted: response.countInserted,
      insertionsStatus: response.insertionsStatus,
      recordsInserted: response.recordsInserted,
    };
  };  

  public static parseCSVError = (errors: any) => {
    return errors[0].messageCode;
  };  
}
